import { GeneralTable, TableTabsScene } from '@/shared/components/ui';
import { useTableFilter } from '@/shared/hooks/useTableFilter';
import { CodigoOTPEstadoEnum, IDataCodigoOtp } from '@/shared/interfaces';
import { useFetchCodigoOTPs } from '@/store/erp/codigos-otp';
import { useColumsTableOTPSupervisor } from '../../shared/hooks';

export type CodigosOTPPendientesProps = {
  estado: string;
};

const CodigosOTPPendientes: React.FC<CodigosOTPPendientesProps> = ({
  estado,
}) => {
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: CodigosOTPPagingRes,
    isLoading,
    isRefetching,
  } = useFetchCodigoOTPs({
    page: pageIndex + 1,
    page_size: pageSize,
    numero_referencia: searchTerm,
    
    estado,
  });

  ///* columns
  const {
    columnsOtpSupervisor,
    columnsOTPSupervisorExpirado,
    columnsOTPSupervisorVerificado,
  } = useColumsTableOTPSupervisor();

  return (
    <TableTabsScene
      onChangeFilter={onChangeFilter}
      globalFilter={globalFilter}
      searchInputText="por número de referencia"
      onChangeRangeDate={()=>{}}
      
    >
      <GeneralTable<IDataCodigoOtp>
        columns={
          estado === CodigoOTPEstadoEnum.PENDIENTE
            ? columnsOtpSupervisor
            : estado === CodigoOTPEstadoEnum.CADUCADO
            ? columnsOTPSupervisorExpirado
            : columnsOTPSupervisorVerificado
        }
        data={CodigosOTPPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={
          estado === CodigoOTPEstadoEnum.PENDIENTE
            ? CodigosOTPPagingRes?.data?.count || 0
            : estado === CodigoOTPEstadoEnum.CADUCADO
            ? CodigosOTPPagingRes?.data?.count || 0
            : CodigosOTPPagingRes?.data?.count || 0
        }
        // // actions
        actionsColumnSize={180}
        // crud
        enableColumnActions={false}
        enableEditing={false}
        canDelete={false}
      />
    </TableTabsScene>
  );
};

export default CodigosOTPPendientes;
